export default "__VITE_ASSET__GBwyxk6c__"